export default function (data) {
  let report =  {
    type: 'component',
    id: 'report',
  };

  if (data.reportType === 'module') {
    report =  {
      type: 'fieldset',
      text: '上报',
      labelWidth: '100px',
      name: 'report',
      extensible: true,
      items: [{
        type: 'row',
        items: [{
          type: 'switch',
          name: 'custom',
          defaultValue: false,
          text: '自定义',
          tip: '选择自定义后可以手动修改上报内容，关闭后会自动生成上报内容',
        }],
      }, {
        name: 'module',
        extensible: true,
        items: [{
          text: '_module',
          disabled: (vm, { values }) => !values?.report?.custom,
          name: '_module',
        }],
      }],
    };
  }

  const form = [{
    title: '属性',
    labelWidth: '120px',
    items: [{
      name: 'id',
      text: 'ID',
      type: 'display',
    }, {
      name: 'type',
      type: 'hidden',
    }, {
      text: 'className',
      name: 'className',
    }, report],
  }, {
    type: 'component',
    id: 'script',
  }];

  if (data.type === 'action-button') {
    form[0].items.push({
      text: '登录后继续执行',
      type: 'switch',
      name: 'afterLoginAction',
      defaultValue: false,
    });
    form.push({
      type: 'component',
      id: 'handler',
    });
  }

  return [{
    title: '高级',
    lazy: true,
    items: [{
      type: 'tab',
      active: '0',
      items: form,
    }],
  }];
}
